/*
################
## SuggestList ##
################

* OPTIONS
    * profileModel: Model of data. Required.
    * optionsList[Array[Objects]]: Labels and values for the options. Required.
    * placeholder[String]: Text in background. Not required.

* EXAMPLE
<SuggestSimpleList
    profileModel="userProfile.testSuggestList"
    optionsList={[{label: 'Hola', value: 1}, {label: 'Chau', value: 2}]}
    isUpdated = {() => {
        console.log("updated");
    }
    {...this.props}
/>

*/
const React = require('react');
const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
const Autosuggest = require('react-autosuggest');
const { Errors } = require('react-redux-form');
import { formatText } from 'core/i18n';
const focusActions = require('actions/focusActions');
const { recordError } = require('utilities/uTagging');
const scroll = require('utilities/scroll');
const Parse = require('autosuggest-highlight/parse');

class SuggestSimpleList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            trigger: false,
            readOnly: false,
            classFocus: '',
            classError: '',
            value: '',
            suggestions: [],
            noResults: false,
        };

        this.handleOnFocus = this.handleOnFocus.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.renderErrors = this.renderErrors.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.handleOnSuggestionsFetchRequested = this.handleOnSuggestionsFetchRequested.bind(this);
        this.handleOnSuggestionsClearRequested = this.handleOnSuggestionsClearRequested.bind(this);
        this.handleOnSuggestionSelected = this.handleOnSuggestionSelected.bind(this);
        this.getSuggestionValue = this.getSuggestionValue.bind(this);
        this.shouldRenderSuggestions = this.shouldRenderSuggestions.bind(this);
        this.onFocusAnimate = this.onFocusAnimate.bind(this);
        this.handleOnRef = this.handleOnRef.bind(this);
        this.divisaderoError = '';
        this.currentElement = null;
    }

    UNSAFE_componentWillMount() {
        const { optionsList, userProfile, profileModel, disabledWhenSelected } = this.props;

        let modelProp;
        if (typeof profileModel !== 'undefined') {
            modelProp = profileModel.split('.')[1];
        }

        if (optionsList.length > 0) {
            let value = typeof userProfile[modelProp] !== 'undefined' ? userProfile[modelProp] : '';
            value = this.getSuggestionsByCode(value.toString(), optionsList);
            if (typeof value[0] !== 'undefined') {
                if (disabledWhenSelected) {
                    this.setState({
                        value: value[0].name,
                        readOnly: true,
                    });
                }
            } else {
                this.setState({
                    value: '',
                    readOnly: false,
                });
            }
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { optionsList, userProfile, profileModel, disabledWhenSelected, resetContent } = nextProps;

        let modelProp;
        if (typeof profileModel !== 'undefined') {
            modelProp = profileModel.split('.')[1];
        }

        if (resetContent) {
            this.setState({
                value: '',
                readOnly: false,
            });
        }

        if (optionsList.length > 0) {
            let value = typeof userProfile[modelProp] !== 'undefined' ? userProfile[modelProp] : '';
            if (value) {
                value = this.getSuggestionsByCode(value.toString(), optionsList);
                if (typeof value[0] !== 'undefined') {
                    this.setState({
                        value: value[0].name,
                        readOnly: disabledWhenSelected,
                    });
                } else {
                    this.setState({
                        value: '',
                        readOnly: false,
                    });
                }
            }
        }

        const { userProfileForm } = nextProps;

        if (typeof userProfileForm[modelProp] !== 'undefined') {
            this.changeClassError(!userProfileForm[modelProp].valid);
        }
    }

    componentDidUpdate() {
        const { profileModel, isUpdated, autofocus, userProfile } = this.props;
        const { investmentType } = userProfile;
        let modelProp;
        if (typeof profileModel !== 'undefined') {
            modelProp = profileModel.split('.')[1];
        }

        if (autofocus) {
            this.refs[modelProp].focus();
        }

        if (this.state.trigger) {
            const { userProfileForm } = this.props;

            if (
                typeof userProfileForm !== 'undefined' &&
                typeof userProfileForm[modelProp] !== 'undefined' &&
                userProfileForm[modelProp].valid
            ) {
                if (isUpdated !== null) {
                    isUpdated();
                }
            } else {
                recordError(modelProp + ':' + this.divisaderoError, investmentType ? investmentType : '');
                this.changeClassError(true);
            }
            this.changeTrigger(false);
        }
    }

    changeTrigger(trigger) {
        this.setState({
            trigger,
        });
    }

    changeClassError(change) {
        const classError = change ? 'react-autosuggest--error valid-error' : '';
        this.setState({
            classError,
        });
    }

    changeClassFocus(change) {
        const classFocus = change ? 'react-autosuggest--focus' : '';
        this.setState({
            classFocus,
        });
    }

    handleOnBlur() {
        const { formActions, userProfile, profileModel, validations } = this.props;
        const modelProp = typeof profileModel !== 'undefined' ? profileModel.split('.')[1] : 'invalidProp';
        const value =
            typeof userProfile[modelProp] !== 'undefined' && userProfile[modelProp] !== null
                ? userProfile[modelProp]
                : '';

        if (validations !== null) {
            formActions.validate(profileModel, validations);
        }

        if (value !== '') {
            formActions.validate(profileModel, { required: true });
        }

        this.setState({
            noResults: false,
        });

        this.changeTrigger(true);
        this.changeClassFocus(false);
    }

    handleClose() {
        const { profileModel, formActions } = this.props;
        const modelProp = typeof profileModel !== 'undefined' ? profileModel.split('.')[1] : 'invalidProp';
        formActions.change(profileModel, '');

        document.getElementById(modelProp).focus();

        this.handleOnSuggestionsClearRequested();
        this.setState({
            value: '',
            readOnly: false,
        });
    }

    handleOnSuggestionsFetchRequested({ value }) {
        this.setState({
            suggestions: this.getSuggestions(value),
        });
    }

    handleOnSuggestionsClearRequested() {
        this.setState({
            suggestions: [],
        });
    }

    handleOnSuggestionSelected(event, { suggestion }) {
        event;
        const { profileModel, formActions, disabledWhenSelected } = this.props;
        formActions.change(profileModel, suggestion.code);
        if (disabledWhenSelected) {
            this.setState({
                readOnly: true,
            });
        }
        formActions.validate(profileModel, { required: true });
        this.changeClassError(false);
        this.changeTrigger(true);
        this.handleOnSuggestionsClearRequested();
        const nextElement = this.currentElement.parentElement.parentElement.nextSibling;
        if (nextElement) {
            setTimeout(() => {
                // setTimeout is necessary because BlockWrapper delays loading
                nextElement.querySelectorAll('input, select')[0].focus();
            }, 100);
        }
    }

    handleOnFocus(event) {
        const { focusAnimated } = this.props;
        this.changeClassFocus(true);
        this.changeClassFocus(true);
        if (focusAnimated) {
            this.onFocusAnimate(event);
        }
    }

    onFocusAnimate(event) {
        let parentElement = event.target.parentElement.parentElement.parentElement.parentElement.parentElement;
        const result = parentElement.className.search('form__radio-list-card');
        if (result === -1) {
            parentElement = event.target.parentElement;
        }
        scroll.transition(parentElement);
    }

    handleOnRef(element) {
        this.currentElement = element;
    }

    onInputChange(event, { newValue }) {
        this.setState({
            value: newValue,
        });
    }

    escapeRegexCharacters(str) {
        return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    getSuggestions(value) {
        const escapedValue = this.escapeRegexCharacters(value.trim());

        if (escapedValue === '') {
            return [];
        }

        const regex = new RegExp(escapedValue, 'i');

        const result = this.props.optionsList.filter(item => regex.test(item.name));

        this.setState({
            noResults: result.length === 0,
        });

        return result;
    }

    getSuggestionsByCode(code, optionsList) {
        const escapedCode = this.escapeRegexCharacters(code.trim());

        if (escapedCode === '') {
            return [];
        }

        const regex = new RegExp(escapedCode, 'i');

        return optionsList.filter(item => regex.test(item.code));
    }

    getSuggestionValue(suggestion) {
        return suggestion.name;
    }

    renderSuggestion(suggestion, { query }) {
        let regex = new RegExp(query, 'gim');
        let match,
            indexes = [];
        match = regex.exec(suggestion.name);
        while (match) {
            indexes.push([match.index, match.index + match[0].length]);
            match = regex.exec(suggestion.name);
        }

        const parts = Parse(suggestion.name, indexes);

        return (
            <span>
                {parts.map((part, index) => {
                    const className = part.highlight
                        ? 'react-autosuggest__suggestion-item react-autosuggest__suggestion-match'
                        : 'react-autosuggest__suggestion-item';

                    return (
                        <span className={className} key={index}>
                            {part.text}
                        </span>
                    );
                })}
            </span>
        );
    }

    shouldRenderSuggestions(value) {
        const { minSearchLength } = this.props;
        return !this.state.readOnly && value.trim().length > minSearchLength;
    }

    renderErrors(props) {
        this.divisaderoError = props.children;
        return <p className="form__field_error">{props.children}</p>;
    }

    render() {
        const { style, label, subTitle, messagesError, profileModel, placeholder, disabled, tooltip } = this.props;
        const noResultsContent = !this.state.noResults ? null : profileModel == 'userProfile.profession_id' ? (
            <div className="react-autosuggest__no-result">{formatText('errors-noResultsNoOptions')}</div>
        ) : (
            <div className="react-autosuggest__no-result">{formatText('errors-noResults')}</div>
        );
        const modelProp = typeof profileModel !== 'undefined' ? profileModel.split('.')[1] : 'invalidProp';
        const className =
            'react-autosuggest react-autosuggest--simple ' + this.state.classFocus + ' ' + this.state.classError;
        let inputClassName = 'react-autosuggest__input ';
        inputClassName = inputClassName + (this.state.readOnly ? 'react-autosuggest__input--readonly' : '');

        let showLabel;
        if (label) {
            showLabel = <label>{label}</label>;
        }
        let showSubTitle;
        if (subTitle) {
            showSubTitle = <span>{subTitle}</span>;
        }

        const { suggestions, value } = this.state;
        const inputProps = {
            className: inputClassName,
            onChange: this.onInputChange,
            id: modelProp,
            name: modelProp,
            disabled: disabled,
            onBlur: this.handleOnBlur,
            onFocus: this.handleOnFocus,
            readOnly: this.state.readOnly,
            placeholder,
            value,
        };

        let closeButton = this.state.readOnly ? (
            <span className="react-autosuggest__close" onClick={this.handleClose}></span>
        ) : null;
        closeButton = !disabled ? closeButton : null;

        return (
            <div className={className} style={style} ref={this.handleOnRef}>
                {showLabel} {showSubTitle}
                {tooltip}
                <div>
                    <Autosuggest
                        inputProps={inputProps}
                        suggestions={suggestions}
                        onSuggestionsFetchRequested={this.handleOnSuggestionsFetchRequested}
                        onSuggestionsClearRequested={this.handleOnSuggestionsClearRequested}
                        onSuggestionSelected={this.handleOnSuggestionSelected}
                        getSuggestionValue={this.getSuggestionValue}
                        renderSuggestion={this.renderSuggestion}
                        shouldRenderSuggestions={this.shouldRenderSuggestions}
                        focusFirstSuggestion={false}
                        alwaysRenderSuggestions={!value}
                    />
                    {closeButton}
                    {noResultsContent}
                </div>
                <Errors model={profileModel} messages={messagesError} component={this.renderErrors} />
            </div>
        );
    }
}

SuggestSimpleList.defaultProps = {
    messagesError: { required: formatText('validation-fieldRequired') },
    label: '',
    onKeyDown: null,
    searchable: false,
    disabled: false,
    style: {},
    autofocus: false,
    focusAnimated: false,
    disabledWhenSelected: true,
    minSearchLength: 2,
    resetContent: false,
};

module.exports.constructor = SuggestSimpleList;
module.exports.SuggestSimpleList = connect(null, dispatch => ({
    focusActions: bindActionCreators(focusActions, dispatch),
}))(SuggestSimpleList);
